import React from "react";
import { IPreviewContact, Nullable, } from "atlas-shared";
import { TFunction, } from "i18next";

export const getContactFullName: any = (contact: Nullable<IPreviewContact>, t: TFunction, skipUndefined: boolean = false) => { 

  if (!contact) 
    return skipUndefined ? "" : t("NO_CONTACT");

  const hasNoName = !contact?.first_name && !contact?.last_name;

  if (hasNoName) 
    return <span style={{ opacity: 0.25 }}>{t("NO_NAME")}</span>; 
 
  return [contact.first_name, contact.last_name, ].filter(Boolean).join(" ");

};
